export default {
    MODE: {
        SERVICE: 'service',
        PARTICIPANT: 'participant'
    }
};
